module.exports = __webpack_public_path__ + "img/1531769062.7ad002e6.jpg";